import clsx from 'clsx';

import styles from 'components/FormControl/Date/styles.module.scss';

import DateService from 'services/DateService';
import { DateUtils } from 'utils';
import { lazyWithRetry } from 'utils/lazy-with-retry';

import calendar from 'assets/icons/calendar.svg';

const DatePicker = lazyWithRetry(() => import('react-datepicker'));

const DateFormControl = (props: any) => {
    const { inputClassName, className, value, onChange, hideCalendar, ...rest } = props;

    return (
        <label className={hideCalendar ? styles.wrapperLabelNoCalendar : styles.wrapperLabel}>
            <div className={clsx(styles.container, className)}>
                <div className={hideCalendar ? 'no-calendar' : 'with-calendar'}>
                    <DatePicker
                        {...rest}
                        selected={DateUtils.toDate(value)}
                        onChange={(d: Date | null) => {
                            if (onChange) {
                                props.onChange(DateUtils.toIsoDateString(d));
                            }
                        }}
                        minDate={new Date('01-01-1900')}
                        showPopperArrow={false}
                        placeholderText={DateUtils.DateDisplayFormat.toLowerCase()}
                        dateFormat={DateUtils.DateDisplayFormat}
                        className={clsx(styles.input, inputClassName)}
                        onChangeRaw={DateService.formatUserInput}
                        calendarClassName={hideCalendar ? 'hidden-calendar' : ''}
                        preventOpenOnFocus={hideCalendar}
                        open={!hideCalendar}
                    />
                </div>
                {!hideCalendar && <img src={calendar} alt="Calendar" className={styles.calendar} />}
            </div>
        </label>
    );
};

export default DateFormControl;
